import { Flex, Text } from "@mantine/core";
import { rolesLabels } from "../../../../utils/vars";
import ConfigCard from "./ConfigCard";

const RoleSection = ({ role, configs, control }) => {
  return (
    <Flex direction="column" gap="sm" miw={460}>
      <Text size="sm" fw={600} pl="md">
        {rolesLabels[role]}
      </Text>
      <Flex gap="md" wrap="wrap">
        {configs.map((config) => (
          <ConfigCard key={config.id} config={config} role={role} control={control} />
        ))}
      </Flex>
    </Flex>
  );
};

export default RoleSection;
